class ImageAPI {
  constructor() {
    this.baseURI = drupalSettings.path.baseUrl + drupalSettings.path.currentLanguage +  '/flink_responsive_images/picture';
  }

  embedMedia(entityId, viewMode) {
    this.entityId = entityId;
    this.viewMode = viewMode;
    return this.callApi();
  }

  embedImage(entityId, viewMode) {
    this.baseURI = drupalSettings.path.baseUrl + drupalSettings.path.currentLanguage + '/flink_images/image';
    this.entityId = entityId;
    this.viewMode = viewMode;
    return this.callApi();
  }

  callApi() {
    return fetch(this.baseURI + '/' + this.entityId + '/' + this.viewMode, {credentials: "same-origin", method: 'GET'})
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then((response) => response.json())
      .then((results) => {return results})
      .catch(() => {console.log('There was an errror');});
  }
}

export default ImageAPI;
